import React, { Component } from 'react';
import '../css/AdviserData.css'
import CommissionPayment from './CommissionPayment';
import ContributorsGraph from './ContributorsGraph';
import FumGraph from './FumGraph';
import MembersGraph from './MembersGraph';
import TotalMembers from './TotalMembers';
import { Container, Col, Row } from 'react-bootstrap';
import { normalizeAngle } from '@amcharts/amcharts4/.internal/core/utils/Math';


class AdviserDataRight extends Component {
    render() {
        //Logic for height of Div
        
        // const numberOfFumCols = this.props.products.length + 1;
        // const totalHeightofFumContainer = 175 * 4;
        // const heightOfAdviserDataRightRow = totalHeightofFumContainer/2;
        return (
        //    <Container fluid>
        //        <Row>
        //             <Col className="adviser-data" style={{height: `${heightOfAdviserDataRightRow}px`}}>
        //                 <MembersGraph advisers={this.props.advisers} total={this.props.advisersTotal}></MembersGraph>
        //             </Col>
        //             <Col className="adviser-data style={{height: `${heightOfAdviserDataRightRow}px`}}">
        //                 <FumGraph advisers={this.props.advisers} total={this.props.advisersTotal}></FumGraph>
        //             </Col>
        //        </Row>
        //        <Row>
        //             <Col className="adviser-data" style={{height: `${heightOfAdviserDataRightRow}px`}}>
        //                 <ContributorsGraph advisers={this.props.advisers} total={this.props.advisersTotal} />
        //             </Col>
        //             <Col className="adviser-data" style={{height: `${heightOfAdviserDataRightRow}px`}}>
        //                 <CommissionPayment {...this.props}></CommissionPayment>
        //             </Col>
        //             <Col className="adviser-data" style={{height: `${heightOfAdviserDataRightRow}px`}}>
        //                 <TotalMembers {...this.props}></TotalMembers>
        //             </Col>
        //        </Row>
        //    </Container>

        //style={{height: `${heightOfAdviserDataRightRow}px`}}
            <table className="adviserData">
                <tbody>
                    <tr>
                        <td colSpan="2" rowSpan="2"><MembersGraph advisers={this.props.advisers} total={this.props.advisersTotal} /></td>
                        <td rowSpan="2" style={{ padding: "50px", verticalAlign: "top"}}><FumGraph advisers={this.props.advisers} total={this.props.advisersTotal} /></td>
                    </tr>
                    <tr>

                    </tr>
                    <tr>
                        <td colSpan="2" rowSpan="2" id="adviserData"><ContributorsGraph advisers={this.props.advisers} total={this.props.advisersTotal} /></td>
                        {/* <td rowSpan="2"><CommissionPayment {...this.props}></CommissionPayment></td> */}
                        <td rowSpan="2"><TotalMembers {...this.props}></TotalMembers></td>
                    </tr>
                    {/* <tr>

                    </tr> */}
                </tbody>
            </table>
        )
    }
}

export default AdviserDataRight